module.exports = __webpack_public_path__ + "static/media/capa-coquetel.d44b1394.png";